import { RichTextIFrameEmbedBlockNode } from '@cinemark/content-api-client';
import type { SerializedBlockNode } from '@payloadcms/richtext-lexical';
import React from 'react';

type RichTextIframeEmbedBlockComponentProps = {
  node: SerializedBlockNode | undefined;
};

export const RichTextIframeEmbedBlockComponent = ({ node }: Readonly<RichTextIframeEmbedBlockComponentProps>): React.JSX.Element | null => {
  if (!node || node.type !== 'block' || !node.fields || typeof node.fields !== 'object' || node.fields.blockType !== 'iframeEmbed') return null;

  const fields = node.fields as unknown as RichTextIFrameEmbedBlockNode;

  if (!fields.src || typeof fields.src !== 'string' || fields.src.trim() === '') {
    return null;
  }

  let urlObj: URL;
  try {
    urlObj = new URL(fields.src);
  } catch {
    return null;
  }

  if (urlObj.protocol !== 'https:') {
    return null;
  }

  const allowedHosts = ['cataboom.com', 'secure.cataboom.com'];

  if (!allowedHosts.includes(urlObj.hostname)) {
    return null;
  }

  const height = fields.height ?? '400px';
  const width = fields.width ?? '100%';

  return (
    <div className="w-full"
      data-test="iframe-embed"
    >
      {fields.title &&
        <h3 className="text-lg font-semibold mb-4"
          data-test="iframe-embed-title"
        >
          {fields.title}
        </h3>
      }
      <iframe allowFullScreen
        className="border-0"
        height={height}
        sandbox="allow-forms allow-same-origin allow-scripts allow-presentation"
        src={fields.src}
        title={fields.title || 'Embedded Content'}
        width={width}
      />
    </div>
  );
};
